// eslint-disable-next-line
export enum EEditGroups {
    PatientStaff = 0,
    PatientOnly = 1,
    StaffOnly = 2,
    PatientStaffLocking = 3,
    PatientOnlyLocking = 4,
    StaffOnlyLocking = 5,
    LockedToAll = 6,
}

// eslint-disable-next-line
export enum EColGroup {
    Col0 = 0,
    Col1 = 1,
    Col2 = 2,
    Col3 = 3,
    Col4 = 4,
    Col5 = 5,
    Col6 = 6,
    Col7 = 7,
    Col8 = 8,
    Col9 = 9,
    Col10 = 10,
    Col11 = 11,
    Col12 = 12,
}

export function isFormElementDisabledAndCannotSave({
    isPatient,
    isStaffer,
    isLocked,
    isActive,
    isComplete,
    editGroup,
}: {
    isPatient: boolean;
    isStaffer: boolean;
    isLocked: boolean;
    isActive: boolean;
    isComplete: boolean;
    editGroup: EEditGroups;
}): boolean {
    // Always disabled if locked or not active
    if (isLocked || !isActive) {
        return true;
    }
    // Handle each edit group case
    switch (editGroup) {
        case EEditGroups.PatientStaff:
            return false; // Always editable for both
        case EEditGroups.StaffOnly:
            return !isStaffer; // Only staff can edit
        case EEditGroups.StaffOnlyLocking:
            return !isStaffer || isComplete; // Staff can edit until complete
        case EEditGroups.PatientOnly:
            return !isPatient; // Only patients can edit
        case EEditGroups.PatientOnlyLocking:
            return !isPatient || isComplete; // Patients can edit until complete
        case EEditGroups.PatientStaffLocking:
            return isComplete; // Both can edit until complete
        case EEditGroups.LockedToAll:
            return true; // Never editable
        default:
            return true; // Default to disabled for unknown edit groups
    }
}
